import {
  importProvidersFrom,
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { NavigationError, provideRouter, Router, withNavigationErrorHandler } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import * as Sentry from '@sentry/angular';
import { OAuthModule } from 'angular-oauth2-oidc';

import { routes } from './app.routes';
import { authInterceptor } from '@ag2-weathermaker/shared/interceptors/auth.inteceptor';
import { AuthService } from '@ag2-weathermaker/core/services/auth/auth.service';
import { ChunkLoadRecoveryService } from '@ag2-weathermaker/core/services/chunk-load-recovery/chunk-load-recovery.service';
import { GlobalErrorHandler } from '@ag2-weathermaker/core/error-handler/global-error-handler';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      // Recover from stale lazy-chunk 404s after a redeploy: silent reload on the blank initial render
      withNavigationErrorHandler((error: NavigationError) => inject(ChunkLoadRecoveryService).handleError(error.error))
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    importProvidersFrom(OAuthModule.forRoot()),
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      // Force instantiation of the TraceService for Sentry tracing setup.
      inject(Sentry.TraceService);
      return inject(AuthService).initialize();
    }),
  ],
};
